/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

export default makeStyles((theme: Theme) =>
  createStyles({
    loginBtn: {
      fontFamily: 'Roboto',
      textTransform: 'none',
      justifyContent: 'flex-start',
      backgroundColor: theme.palette.common.white,
      padding: theme.spacing(1.375, 2, 1.375, 7.5),
    },
    loginBtnEmbedded: {
      fontFamily: 'Roboto',
      textTransform: 'none',
      justifyContent: 'flex-start',
      backgroundColor: theme.palette.common.white,
      padding: theme.spacing(1.375, 2, 1.375, 4.5),
    },
    btnIcon: {
      marginRight: theme.spacing(2),
      fontSize: theme.spacing(2.25),
      display: 'flex',
      alignItems: 'center',
      '& svg': {
        width: '1em',
        height: '1em',
      },
    },
    btnText: {
      display: 'flex',
      justifyContent: 'center',
      fontWeight: 500,
      color: theme.palette.common.black,
      fontSize: theme.spacing(1.75),
    },
  })
);
